module.exports = __webpack_public_path__ + "img/Procrastination.fa7642a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Procrastination.png
// module id = ucvR
// module chunks = 0